import { Cookie } from "./cookie";

export type Flag = string;
export type FeatureFlags = Record<Flag, boolean>;

export class FeatureFlagProvider {
	private static instance: FeatureFlagProvider;
	private flags: FeatureFlags;
	public readonly modifiedFlags: Flag[];

	public static getInstance(featureFlags: FeatureFlags): FeatureFlagProvider {
		if (!FeatureFlagProvider.instance) {
			FeatureFlagProvider.instance = new FeatureFlagProvider(featureFlags);
		}
		return FeatureFlagProvider.instance;
	}

	public static resetInstance(flags: FeatureFlags): void {
		const instance = FeatureFlagProvider.getInstance(flags);

		instance.flags = flags;
	}

	public constructor(featureFlags: FeatureFlags) {
		this.flags = featureFlags;

		this.modifiedFlags = Cookie.get("bm-feature-flags", "")
			.split("&")
			.map((flag) => {
				return flag.replace(/_\d$/, "");
			})
			.filter(Boolean);
	}

	public isEnabled(flag: Flag): boolean {
		return !!this.flags[flag];
	}

	public setFeatureFlag(name: Flag, enabled: boolean): void {
		const newUrl = new URL(location.href);

		newUrl.searchParams.delete("feature-flags");
		newUrl.searchParams.set("feature-flags", `${name}_${enabled ? "1" : "0"}`);

		location.href = newUrl.toString();
	}

	public getFlags(): FeatureFlags {
		return this.flags;
	}

	public getModifiedFlags(): Flag[] {
		return this.modifiedFlags;
	}
}
